import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { CUST_ID } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";

interface FeedbackModalProps {
  show: boolean;
  onClose: () => void;
  getServiceData: any;
  fetchServiceRequestAPI: any;
  setOpenModal: any;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  setOpenModal,
  show,
  onClose,
  getServiceData,
  fetchServiceRequestAPI,
}) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const customerid = localStorage.getItem(CUST_ID);
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiProtocol = process.env.REACT_APP_API_PROTOCOL;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("customer-token");

  const feedbackSubmitApi = async () => {
    if (rating === 0 || !message.trim()) {
      toast.error("Please provide rating and feedback before submitting.");
      return;
    }

    const submitObj = {
      customer: customerid,
      workshop: getServiceData?.workshop_id,
      appointment: getServiceData?.appointment_id,
      feedback: message.trim(),
      rating,
    };

    setLoading(true);
    try {
      const response = await axios.post(
        `${apiProtocol}://${fetchingTenant}.${baseUrl}/v1/gc/workshop-feedback/`,
        submitObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const resData = response?.data;
      const status =
        resData?.data?.status?.toLowerCase?.() ||
        resData?.status?.toLowerCase?.() ||
        resData?.result?.toLowerCase?.() ||
        "";

      if (status === "success") {
        toast.success("Feedback submitted successfully");
        setRating(0);
        setMessage("");
        onClose();
        fetchServiceRequestAPI();
        // setOpenModal(""); // Optional: uncomment if needed
      } else {
        const errorMsg =
          resData?.data?.message ||
          resData?.message ||
          resData?.error ||
          "Failed to submit feedback. Please try again.";
        toast.error(errorMsg);
      }
    } catch (error: any) {
      console.error("Error submitting feedback:", error);
      const errData = error?.response?.data;
      let errorMsg = "An unexpected error occurred. Please try again.";

      if (typeof errData === "string") {
        errorMsg = errData;
      } else if (errData?.message) {
        errorMsg = errData.message;
      } else if (errData && typeof errData === "object") {
        const firstKey = Object.keys(errData)[0];
        const firstMsg = Array.isArray(errData[firstKey])
          ? errData[firstKey][0]
          : errData[firstKey];
        errorMsg = firstMsg || errorMsg;
      }

      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header
        className="justify-content-center position-relative"
        style={{ borderBottom: "none" }}
      >
        <div
          style={{
            width: "100%",
            textAlign: "center",
            fontWeight: 600,
            fontFamily: "Karbon-semi",
            marginBottom: "8px",
          }}
        >
          Please Share Your Experience With{" "}
          <span style={{ fontSize: "20px" }}>
            {capitalizeFirstLetter(
              getServiceData?.booking_request?.workshop_details?.name
            )}
          </span>
        </div>
        <button
          type="button"
          className="btn-close position-absolute"
          style={{ right: 16, top: 16 }}
          aria-label="Close"
          onClick={onClose}
          disabled={loading}
        />
      </Modal.Header>

      <Modal.Body style={{ padding: "1rem" }}>
        <div
          className="text-center"
          style={{ marginBottom: "10px", marginTop: "-8px" }}
        >
          {[1, 2, 3, 4, 5].map((star) => (
            <i
              key={star}
              className={`bi ${
                star <= (hover || rating)
                  ? "bi-star-fill text-warning"
                  : "bi-star"
              } fs-4 mx-1`}
              style={{ cursor: "pointer" }}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
            />
          ))}
        </div>
        <Form.Group className="mb-3">
          <Form.Label style={{ fontFamily: "Karbon-semi" }}>
            Your Feedback
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Write Your Thoughts Here"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            disabled={loading}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          style={{
            whiteSpace: "nowrap",
            minWidth: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.6rem",
            fontSize: "16px",
            fontWeight: 600,
            border: "none",
            borderRadius: "20px",
            padding: "0.85rem 1.2rem",
            transition: "background 0.2s",
            fontFamily: "Karbon-medium",
            cursor: "pointer",
            background: "#f0f0f0",
            color: "#333",
            marginRight: "10px",
          }}
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="button"
          style={{
            whiteSpace: "nowrap",
            minWidth: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.6rem",
            fontSize: "16px",
            fontWeight: 600,
            border: "none",
            borderRadius: "20px",
            padding: "0.85rem 1.2rem",
            transition: "background 0.2s",
            fontFamily: "Karbon-medium",
            cursor: loading ? "not-allowed" : "pointer",
            background: loading ? "#ccc" : "#ff6600",
            color: "white",
          }}
          onClick={feedbackSubmitApi}
          disabled={loading || rating === 0 || !message.trim()}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackModal;
